const data = [
  {
    group: '全部',
    data: [
      {
        name: '360安全中心',
        icon: require('../../assets/21.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/f4/17452/360aqws_10.2.0.2001_setup.1457072816.exe'
      }, {
        name: '美图秀秀',
        icon: require('../../assets/31.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/24/13406/XiuXiu_V4.0.1.2002_BdSetup.1437647987.exe'
      }, {
        name: 'Microsoft Office',
        icon: require('../../assets/12.png'),
        url: 'http://www.baidu.com/'
      }, {
        name: '百度卫士',
        icon: require('../../assets/116.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/70/17456/BaiduAn_Setup_8.1.0.7141.1457068013.exe',
      },{
        name: 'Adobe Reader',
        icon: require('../../assets/108.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/31/12612/AdbeRdr11000_zh_CN11.0.0.379.1410747856.exe',
      },{
        name: '海词词典',
        icon: require('../../assets/23.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/b6/14283/haicicidianruanjian.1409210206.exe',
      },{
        name: 'IE Tester',
        icon: require('../../assets/106.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/7f/14886/install-ietester-v0.5.4.1416988183.exe',
      },{
        name: 'Dreamweaver 8',
        icon: require('../../assets/104.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/d5/13828/Dreamweaver8-chs_8.0.0.2766.1392796602.exe',
      },{
        name: 'EditPlus',
        icon: require('../../assets/105.png'),
        url: 'http://www.baidu.com/',
      },{
        name: 'Notepad++',
        icon: require('../../assets/107.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/cc/13478/npp_6.9_Installer.1456209569.exe',
      },{
        name: '搜狗输入法',
        icon: require('../../assets/14.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/8a/13598/sogou_pinyin_7.9.0.7504_6991.1457060046.exe',
      },{
        name: '有道词典',
        icon: require('../../assets/24.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/b8/14630/YoudaoDict_V6.3.67.7016_setup.1439368979.exe',
      },{
        name: '好压',
        icon: require('../../assets/34.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/c5/13643/haozip_baidu_5.6.1.10516_setup.1457059746.exe',
      },{
        name: '谷歌浏览器',
        icon: require('../../assets/15.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/78/17803/GoogleChromeframeStandaloneEnterprise.4144293914.msi',
      },{
        name: '火狐浏览器',
        icon: require('../../assets/25.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/51/11843/Firefox_44.0.2.5884_setup.1455503094.exe',
      },{
        name: '搜狗浏览器',
        icon: require('../../assets/16.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/0d/14754/sogou_explorer_6.1.5.20472_setup.1456908041.exe',
      },{
        name: '360浏览器',
        icon: require('../../assets/102.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/de/24437/360sebeta_8.1.1.118_setup.1450688318.exe',
      },{
        name: 'Java',
        icon: require('../../assets/JAVA.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/52/14459/jdk_8u73_windows_i586_8.0.730.2.1455434099.exe',
      },{
        name: 'PDF转换器',
        icon: require('../../assets/13.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/55/26919/OfficezhuanhuanchengPDFzhuanhuanqi.1400062108.exe',
      },{
        name: 'Safari',
        icon: require('../../assets/110.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/d3/12966/Safari_5.34.57.2.1417745549.exe',
      },{
        name: '百度输入法',
        icon: require('../../assets/114.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/40/13323/BaiduPinyinSetup_3.3.2.1157.1453267011.exe',
      },{
        name: 'QQ拼音输入法',
        icon: require('../../assets/109.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/2b/12883/QQPinyin_Setup_5.2.3043.400.1456829390.exe',
      },{
        name: '百度五笔输入法',
        icon: require('../../assets/115.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/94/23191/BaiduWubi_1.2.0.66_Setup.1447990267.exe',
      },{
        name: '百度杀毒',
        icon: require('../../assets/116.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/44/17448/Baidusd_Setup_5.1.0.8584.1456217904.exe',
      },{
        name: '360杀毒',
        icon: require('../../assets/103.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/58/17450/360sd_std_5.0.0.6123.1452059643.exe',
      },{
        name: '金山卫士',
        icon: require('../../assets/113.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/58/17450/360sd_std_5.0.0.6123.1452059643.exe',
      },{
        name: 'winRAR',
        icon: require('../../assets/111.png'),
        url: 'http://www.baidu.com/',
      },{
        name: '7-Zip',
        icon: require('../../assets/101.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/37/11063/7z_15.14.0.0_setup.1453706633.exe',
      },{
        name: '.Net',
        icon: require('../../assets/119.png'),
        url: 'http://www.zt-express.com/download/DotNetFx40_Full_x86_x64.exe',
      },

    ]
  }, {
    group: '办公软件',
    data: [
      {
        name: 'Microsoft Office',
        icon: require('../../assets/12.png'),
        url: 'http://www.baidu.com/'
      },{
        name: '美图秀秀',
        icon: require('../../assets/31.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/24/13406/XiuXiu_V4.0.1.2002_BdSetup.1437647987.exe'
      },{
        name: 'Adobe Reader',
        icon: require('../../assets/108.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/31/12612/AdbeRdr11000_zh_CN11.0.0.379.1410747856.exe',
      },{
        name: '海词词典',
        icon: require('../../assets/23.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/b6/14283/haicicidianruanjian.1409210206.exe',
      },{
        name: '有道词典',
        icon: require('../../assets/24.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/b8/14630/YoudaoDict_V6.3.67.7016_setup.1439368979.exe',
      },{
        name: 'PDF转换器',
        icon: require('../../assets/13.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/55/26919/OfficezhuanhuanchengPDFzhuanhuanqi.1400062108.exe',
      },
    ]
  },{
    group: '浏览器',
    data: [
      {
        name: '谷歌浏览器',
        icon: require('../../assets/15.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/78/17803/GoogleChromeframeStandaloneEnterprise.4144293914.msi',
      },{
        name: '火狐浏览器',
        icon: require('../../assets/25.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/51/11843/Firefox_44.0.2.5884_setup.1455503094.exe',
      },{
        name: '搜狗浏览器',
        icon: require('../../assets/16.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/0d/14754/sogou_explorer_6.1.5.20472_setup.1456908041.exe',
      },{
        name: '360浏览器',
        icon: require('../../assets/102.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/de/24437/360sebeta_8.1.1.118_setup.1450688318.exe',
      },{
        name: 'Safari',
        icon: require('../../assets/110.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/d3/12966/Safari_5.34.57.2.1417745549.exe',
      },{
        name: '遨游浏览器',
        icon: require('../../assets/112.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/6d/15449/mx_4.9.1.1000_cn_setup.1457331594.exe',
      },
    ]
  },
  {
    group: '输入法',
    data: [
      {
        name: '百度输入法',
        icon: require('../../assets/114.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/40/13323/BaiduPinyinSetup_3.3.2.1157.1453267011.exe',
      },{
        name: 'QQ拼音输入法',
        icon: require('../../assets/109.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/2b/12883/QQPinyin_Setup_5.2.3043.400.1456829390.exe',
      },{
        name: '百度五笔输入法',
        icon: require('../../assets/115.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/94/23191/BaiduWubi_1.2.0.66_Setup.1447990267.exe',
      },{
        name: '搜狗输入法',
        icon: require('../../assets/14.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/8a/13598/sogou_pinyin_7.9.0.7504_6991.1457060046.exe',
      },
    ]
  },{
    group: '安全杀毒',
    data: [
      {
        name: '百度卫士',
        icon: require('../../assets/116.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/70/17456/BaiduAn_Setup_8.1.0.7141.1457068013.exe',
      },{
        name: '百度杀毒',
        icon: require('../../assets/116.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/44/17448/Baidusd_Setup_5.1.0.8584.1456217904.exe',
      },{
        name: '360杀毒',
        icon: require('../../assets/103.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/58/17450/360sd_std_5.0.0.6123.1452059643.exe',
      },{
        name: '金山卫士',
        icon: require('../../assets/113.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/58/17450/360sd_std_5.0.0.6123.1452059643.exe',
      },{
        name: '360安全中心',
        icon: require('../../assets/21.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/f4/17452/360aqws_10.2.0.2001_setup.1457072816.exe'
      },
    ]
  },{
    group: '压缩刻录',
    data: [
      {
        name: '好压',
        icon: require('../../assets/34.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/c5/13643/haozip_baidu_5.6.1.10516_setup.1457059746.exe',
      },{
        name: 'winRAR',
        icon: require('../../assets/111.png'),
        url: 'http://www.baidu.com/',
      },{
        name: '7-Zip',
        icon: require('../../assets/101.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/37/11063/7z_15.14.0.0_setup.1453706633.exe',
      },
    ]
  },{
    group: '编程开发',
    data: [
      {
        name: 'Java',
        icon: require('../../assets/JAVA.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/52/14459/jdk_8u73_windows_i586_8.0.730.2.1455434099.exe',
      },{
        name: 'IE Tester',
        icon: require('../../assets/106.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/7f/14886/install-ietester-v0.5.4.1416988183.exe',
      },{
        name: 'Dreamweaver 8',
        icon: require('../../assets/104.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/d5/13828/Dreamweaver8-chs_8.0.0.2766.1392796602.exe',
      },{
        name: 'EditPlus',
        icon: require('../../assets/105.png'),
        url: 'http://www.baidu.com/',
      },{
        name: 'Notepad++',
        icon: require('../../assets/107.png'),
        url: 'http://dlsw.baidu.com/sw-search-sp/soft/cc/13478/npp_6.9_Installer.1456209569.exe',
      },{
        name: '.Net',
        icon: require('../../assets/119.png'),
        url: 'http://www.zt-express.com/download/DotNetFx40_Full_x86_x64.exe',
      },
    ]
  }

];

export {data}


// WEBPACK FOOTER //
// ./src/pages/Download/download.config.js